// src/Sidebar.js
import { useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DashboardIcon from "../src/sidebar-svg.svg";
import DashboardBlack from "../src/DashboardIcon02.svg";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import SchemaIcon from "@mui/icons-material/Schema";
import AssessmentIcon from "@mui/icons-material/Assessment";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

import {
  CssBaseline,
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography,
} from "@mui/material";
import {
  Menu as MenuIcon,
  ChevronLeft as ChevronLeftIcon,
  WarehouseRounded,
} from "@mui/icons-material";
import ProfileDetails from "./components/ProfileDetails";
import { checkIsAdmin } from "./helpers";
// import "./Sidebar.css"; // CSS file for styling

function Sidebar({ open, setOpen }) {
  const drawerWidth = 260;
  // const [open, setOpen] = useState(true); // State for toggling the drawer open/close
  const [selectedMenu, setSelectedMenu] = useState("Summary");

  const handleMenuClick = (menuName) => {
    setSelectedMenu(menuName);
    setOpen(false);
  };
  const location = useLocation();
  const isAdmin = checkIsAdmin();

  // Update selectedMenu dynamically based on the current route
  useEffect(() => {
    const pathToMenuMap = {
      "/": "Test Summary",
      "/current-month-summary": "Summary",
      "/current-month": "Day Level",
      "/future-month": "Future Month",
      "/scheme": "View / Edit Schemes",
      "/usermaster": "User Master",
      "/pricelist": "PriceList",
      "/product-master": "Product Master",
      "/po-summary": "Purchase Orders",
      "/van-targets": "Van Targets",
    };

    const currentPath = location.pathname;
    setSelectedMenu(pathToMenuMap[currentPath] || "Summary");
  }, [location.pathname]);

  const toggleDrawer = () => {
    setOpen(!open);
  };
  return (
    <div style={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        style={{
          // width: open ? `calc(100% - ${drawerWidth}px)` : "100%",
          // marginLeft: open ? drawerWidth : 0,
          backgroundColor: "#fff",
          color: "white",
          transition: "width 0.3s ease",
          zIndex: "11",
        }}
      >
        <Toolbar>
          <IconButton
            color="#000"
            aria-label="open drawer"
            onClick={toggleDrawer}
            edge="start"
            sx={{ marginRight: "16px" }}
          >
            {open ? <ChevronLeftIcon /> : <MenuIcon />}
          </IconButton>
          <div
            style={{
              display: "flex",
              gap: "20px",
              alignItems: "center",
              marginRight: "16px",
            }}
          >
            <img
              src="https://www.idfreshfood.com/wp-content/uploads/2019/07/new-logo-120-1.png"
              alt="Company Logo"
              style={{
                width: "45px",
                height: "45px",
              }}
            />
            <h3
              style={{
                fontSize: "14px",
                fontWeight: "600",
                color: "#000",
              }}
            >
              Month Planner
            </h3>
          </div>
          <Typography
            sx={{
              fontSize: "14px",
              color: "#000",
            }}
            variant="h6"
            noWrap
          >
            ({selectedMenu})
          </Typography>
          <ProfileDetails />
        </Toolbar>
      </AppBar>
      <Drawer
        sx={{
          width: open ? drawerWidth : 0,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: open ? drawerWidth : 0,
            transition: "width 0.3s", // Smooth transition for drawer open/close
            boxSizing: "border-box",
            backgroundColor: "#fff", // Drawer background color
            color: "white", // Drawer text color
            zIndex: "10",
            paddingTop: "135px",
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <section
          style={{
            display: "flex",
            flexDirection: "column",
            // gap: "40px",
          }}
        >
          {/* <div
            style={{
              display: "flex",
              gap: "20px",
              alignItems: "center",
            }}
          >
            <img
              src="https://www.idfreshfood.com/wp-content/uploads/2019/07/new-logo-120-1.png"
              alt="Company Logo"
              style={{
                width: "60px",
                height: "60px",
              }}
            />
            <h3
              style={{
                fontSize: "20px",
                fontWeight: "600",
              }}
            >
              Month Planner
            </h3>
          </div> */}
          <List
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "15px",
            }}
          >
            {/* <ListItem
            style={{ 
              color: "white",
              backgroundColor: location.pathname === "/" ? "#17A591" : "transparent",

             }}
            button
            component={Link}
            to='/'
            onClick={() => handleMenuClick("Summary")}
          >
            <ListItemText primary='Summary' />
          </ListItem> */}
           {(isAdmin === "1" || isAdmin === "0" ) && (
            <>
            <ListItem
              style={{
                color: "black",
                borderRadius: "4px",
                gap: "15px",
                color:
                  location.pathname === "/current-month-summary"
                    ? "#fff"
                    : "#000",
                backgroundColor:
                  location.pathname === "/current-month-summary"
                    ? "#17A591"
                    : "transparent",
              }}
              button
              component={Link}
              to="/current-month-summary"
              onClick={() => handleMenuClick("Summary")}
              className="side-bar-list"
              sx={{
                "&:hover": {
                  color: "#fff", // Change color on hover
                },
                "&:hover .MuiSvgIcon-root": {
                  color: "#fff", // Change icon color on hover
                },
                "&:hover .MuiListItemText-primary": {
                  color: "#fff", // Change text color on hover
                },
              }}
            >
              <AssessmentIcon />
              <ListItemText
                sx={{
                  "& .MuiListItemText-primary": {
                    fontSize: "14px",
                  },
                }}
                primary="Summary"
              />
            </ListItem>
            {/* <ListItem
              style={{
                color: "white",
                backgroundColor: location.pathname === "/current-month" ? "#17A591" : "transparent",
              }}
              button
              component={Link}
              to='/current-month'
              onClick={() => handleMenuClick("Current Month")}
            >
              <ListItemText primary='Edit Current Month' />
            </ListItem> */}
            {/* <ListItem
              style={{
                color: "white",
                backgroundColor: location.pathname === "/future-month" ? "#17A591" : "transparent",
              }}
              button
              component={Link}
              to='/future-month'
              onClick={() => handleMenuClick("Future Month")}
            >
              <ListItemText primary='Edit Future Month' />
            </ListItem> */}
            {/* <ListItem
            style={{ color: "white" }}
            button
            component={Link}
            to='/scheme'
            onClick={() => handleMenuClick("Scheme")}
          >
            <ListItemText primary='Scheme' />
          </ListItem> */}
            <ListItem
              style={{
                gap: "15px",
                borderRadius: "4px",
                color: location.pathname === "/scheme" ? "#fff" : "#000",
                backgroundColor:
                  location.pathname === "/scheme" ? "#17A591" : "transparent",
                color: location.pathname === "/scheme" ? "#fff" : "#000",
              }}
              button
              component={Link}
              to="/scheme"
              onClick={() => handleMenuClick("Scheme")}
              className="side-bar-list"
              sx={{
                "&:hover": {
                  color: "#fff", // Change color on hover
                },
                "&:hover .MuiSvgIcon-root": {
                  color: "#fff", // Change icon color on hover
                },
                "&:hover .MuiListItemText-primary": {
                  color: "#fff", // Change text color on hover
                },
              }}
            >
              <SchemaIcon />
              <ListItemText
                sx={{
                  "& .MuiListItemText-primary": {
                    fontSize: "14px",
                  },
                }}
                primary="View / Edit Schemes"
              />
            </ListItem>


            <ListItem
              style={{
                gap: "15px",
                borderRadius: "4px",
                color: location.pathname === "/scheme-analysis" ? "#fff" : "#000",
                backgroundColor:
                  location.pathname === "/scheme-analysis" ? "#17A591" : "transparent",
                color: location.pathname === "/scheme-analysis" ? "#fff" : "#000",
              }}
              button
              component={Link}
              to="/scheme-analysis"
              onClick={() => handleMenuClick("Scheme-analysis")}
              className="side-bar-list"
              sx={{
                "&:hover": {
                  color: "#fff", // Change color on hover
                },
                "&:hover .MuiSvgIcon-root": {
                  color: "#fff", // Change icon color on hover
                },
                "&:hover .MuiListItemText-primary": {
                  color: "#fff", // Change text color on hover
                },
              }}
            >
              <SchemaIcon />
              <ListItemText
                sx={{
                  "& .MuiListItemText-primary": {
                    fontSize: "14px",
                  },
                }}
                primary="Scheme Analysis"
              />
            </ListItem>
            </>
           )}
            {/* <ListItem
              style={{
                color: "white",
                backgroundColor: location.pathname === "/" ? "#17A591" : "transparent",

              }}
              button
              component={Link}
              to='/'
              onClick={() => handleMenuClick("Test Summary")}
            >
              <ListItemText primary='Test Summary' />
            </ListItem> */}
            {/* <ListItem
               style={{ 
                color: "white",
                backgroundColor: location.pathname === "/review" ? "#17A591" : "transparent",
               }}
            button
            component={Link}
            to='/review'
            onClick={() => handleMenuClick("Review")}
          >
            <ListItemText primary='Review' />
          </ListItem> */}
            {/* <ListItem
            style={{ color: "white" }}
            button
            component={Link}
            to='/dropdown'
            onClick={() => handleMenuClick("dropdown")}
          >
            <ListItemText primary='dropdown' />
          </ListItem>
           <ListItem
            style={{ color: "white" }}
            button
            component={Link}
            to='/ag-summary'
            onClick={() => handleMenuClick("AG Summary")}
          >
            <ListItemText primary='AG Summary' />
          </ListItem>
          <ListItem
            style={{ color: "white" }}
            button
            component={Link}
            to='/ag-current-month'
            onClick={() => handleMenuClick("AG Current month")}
          >
            <ListItemText primary='AG Current month' />
          </ListItem> */}
            {(!isAdmin || isAdmin === "1") && (
              <ListItem
                style={{
                  gap: "15px",
                  borderRadius: "4px",

                  color: location.pathname === "/usermaster" ? "#fff" : "#000",
                  backgroundColor:
                    location.pathname === "/usermaster"
                      ? "#17A591"
                      : "transparent",
                  color: location.pathname === "/usermaster" ? "#fff" : "#000",
                }}
                button
                component={Link}
                to="/usermaster"
                onClick={() => handleMenuClick("User Master")}
                className="side-bar-list"
                sx={{
                  "&:hover": {
                    color: "#fff", // Change color on hover
                  },
                  "&:hover .MuiSvgIcon-root": {
                    color: "#fff", // Change icon color on hover
                  },
                  "&:hover .MuiListItemText-primary": {
                    color: "#fff", // Change text color on hover
                  },
                }}
              >
                <PeopleAltIcon />

                <ListItemText
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontSize: "14px",
                    },
                  }}
                  primary="User Master"
                />
              </ListItem>
            )}
            {(!isAdmin || isAdmin === 1) && (
              <ListItem
                style={{
                  gap: "15px",
                  borderRadius: "4px",

                  color: location.pathname === "/pricelist" ? "#fff" : "#000",
                  backgroundColor:
                    location.pathname === "/pricelist"
                      ? "#17A591"
                      : "transparent",
                  color: location.pathname === "/pricelist" ? "#fff" : "#000",
                }}
                button
                component={Link}
                to="/pricelist"
                onClick={() => handleMenuClick("PriceList")}
                className="side-bar-list"
                sx={{
                  "&:hover": {
                    color: "#fff", // Change color on hover
                  },
                  "&:hover .MuiSvgIcon-root": {
                    color: "#fff", // Change icon color on hover
                  },
                  "&:hover .MuiListItemText-primary": {
                    color: "#fff", // Change text color on hover
                  },
                }}
              >
                <LocalOfferIcon />
                <ListItemText
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontSize: "14px",
                    },
                  }}
                  primary="Pricelist"
                />
              </ListItem>
            )}
            {(!isAdmin || isAdmin === "1") && (
              <ListItem
                style={{
                  gap: "15px",
                  borderRadius: "4px",

                  color:
                    location.pathname === "/product-master" ? "#fff" : "#000",
                  backgroundColor:
                    location.pathname === "/product-master"
                      ? "#17A591"
                      : "transparent",
                  color:
                    location.pathname === "/product-master" ? "#fff" : "#000",
                }}
                button
                component={Link}
                to="/product-master"
                onClick={() => handleMenuClick("product-master")}
                className="side-bar-list"
                sx={{
                  "&:hover": {
                    color: "#fff", // Change color on hover
                  },
                  "&:hover .MuiSvgIcon-root": {
                    color: "#fff", // Change icon color on hover
                  },
                  "&:hover .MuiListItemText-primary": {
                    color: "#fff", // Change text color on hover
                  },
                }}
              >
                <LocalOfferIcon />
                <ListItemText
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontSize: "14px",
                    },
                  }}
                  primary="product-master"
                />
              </ListItem>
            )}
             {(isAdmin === "1" || isAdmin === "0") && (
            <ListItem
                style={{
                  gap: "15px",
                  borderRadius: "4px",

                  color: location.pathname === "/po-summary" ? "#fff" : "#000",
                  backgroundColor:
                    location.pathname === "/po-summary"
                      ? "#17A591"
                      : "transparent",
                  color: location.pathname === "/po-summary" ? "#fff" : "#000",
                }}
                button
                component={Link}
                to="/po-summary"
                onClick={() => handleMenuClick("Purchase Orders")}
                className="side-bar-list"
                sx={{
                  "&:hover": {
                    color: "#fff", // Change color on hover
                  },
                  "&:hover .MuiSvgIcon-root": {
                    color: "#fff", // Change icon color on hover
                  },
                  "&:hover .MuiListItemText-primary": {
                    color: "#fff", // Change text color on hover
                  },
                }}
              >
                <LocalOfferIcon />

                <ListItemText
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontSize: "14px",
                    },
                  }}
                  primary="Purchase Orders"
                />
            </ListItem>
             )}
            {(isAdmin === "1" || isAdmin === "2") && (
              <ListItem
                  style={{
                    gap: "15px",
                    borderRadius: "4px",

                    color: location.pathname === "/invoice-retrieval" ? "#fff" : "#000",
                    backgroundColor:
                      location.pathname === "/invoice-retrieval"
                        ? "#17A591"
                        : "transparent",
                    color: location.pathname === "/invoice-retrieval" ? "#fff" : "#000",
                  }}
                  button
                  component={Link}
                  to="/invoice-retrieval"
                  onClick={() => handleMenuClick("Invoice Retrieval")}
                  className="side-bar-list"
                  sx={{
                    "&:hover": {
                      color: "#fff", // Change color on hover
                    },
                    "&:hover .MuiSvgIcon-root": {
                      color: "#fff", // Change icon color on hover
                    },
                    "&:hover .MuiListItemText-primary": {
                      color: "#fff", // Change text color on hover
                    },
                  }}
                >
                  <LocalOfferIcon />

                  <ListItemText
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontSize: "14px",
                      },
                    }}
                    primary="Invoice Retrieval"
                  />
              </ListItem>
            )}
            {(isAdmin === "1" || isAdmin === "0") && (
              <ListItem
                style={{
                  gap: "15px",
                  borderRadius: "4px",

                  color: location.pathname === "/van-targets" ? "#fff" : "#000",
                  backgroundColor:
                    location.pathname === "/van-targets"
                      ? "#17A591"
                      : "transparent",
                  color: location.pathname === "/van-targets" ? "#fff" : "#000",
                }}
                button
                component={Link}
                to="/van-targets"
                onClick={() => handleMenuClick("Van Targets")}
                className="side-bar-list"
                sx={{
                  "&:hover": {
                    color: "#fff", // Change color on hover
                  },
                  "&:hover .MuiSvgIcon-root": {
                    color: "#fff", // Change icon color on hover
                  },
                  "&:hover .MuiListItemText-primary": {
                    color: "#fff", // Change text color on hover
                  },
                }}
              >
                <LocalShippingIcon />

                <ListItemText
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontSize: "14px",
                    },
                  }}
                  primary="Van Targets"
                />
              </ListItem>
            )}
          </List>
        </section>
      </Drawer>
      <main
        style={{
          flexGrow: 1,
          // padding: "20px",
          paddingTop: "20px",
          marginLeft: open ? drawerWidth : 0,
          transition: "All 0.3s ease",
          transition: "margin-left 0.3s ease",
        }}
      >
        <Toolbar />
      </main>
    </div>
  );
}

export default Sidebar;
